import { getRefreshToken } from '@/shahrzad-assets/shared-constants/localstorage'
import { message } from 'antd'
import { errorMessage } from '@/shahrzad-assets/shared-constants/apiErrors'
import { updateAccessToken } from '@/shahrzad-assets/shared-api/api'
import { setAuthInformation } from '../shared-utils/checkExpireInToken'
import { forbidUrlsForShowMessage } from './forbidShowError'
import { logout } from '../shared-utils/logout'

interface IMessages {
  code: number
  message: string
}

const errorMessageHandler = (messages: IMessages[]) => {
  for (const m of messages) {
    message.error(m.message)
  }
}

export const ErrorHandler = async (error) => {
  if (error.response) {
    const refreshToken = getRefreshToken()
    switch (error.response.status) {
      case 401:
        if (refreshToken) {
          const response = await updateAccessToken({ refreshToken }).catch(
            (error) => logout(),
          )
          setAuthInformation(
            response?.refreshToken,
            response?.accessToken,
            response?.expiresIn,
          )
          window.location.reload()
        }
        break
      case 403:
        message.error(errorMessage.forbidden)
        break
      case 404:
        break
      case 500:
        if (error?.response?.data?.message)
          message.error(error?.response?.data?.message)
        else message.error(errorMessage.server)
        break
      case 400:
        if (error.request.responseURL.includes(forbidUrlsForShowMessage)) return

        const responseData = error?.response?.data

        // Helper function to display error message
        const showMessage = (msg) =>
          message.error(msg || errorMessage.dataUnvalid)

        // Handle different error message formats
        if (
          responseData?.message &&
          responseData.message !== 'serializer error'
        ) {
          showMessage(responseData.message)
        } else if (responseData?.detail) {
          showMessage(responseData?.detail)
        } else if (
          responseData &&
          !responseData?.messages &&
          !responseData?.message
        ) {
          message.error(responseData)
        } else if (
          typeof responseData?.messages === 'object' &&
          !Array.isArray(responseData.messages)
        ) {
          showMessage(responseData.messages.message)
        } else if (
          Array.isArray(responseData?.messages) &&
          responseData.messages[0]?.message
        ) {
          try {
            const parsedMessage = JSON.parse(responseData.messages[0].message)
            showMessage(parsedMessage.messages || parsedMessage.message)
          } catch {
            showMessage(responseData.messages[0].message)
          }
        } else if (responseData?.messages) {
          errorMessageHandler(responseData.messages)
        } else if (responseData?.errors) {
          showMessage(Object.values(responseData.errors)[0])
        } else {
          showMessage()
        }
        break

      default:
        showMessage(responseData?.message ?? errorMessage.fail)
        break
    }
  } else if (error.request) {
    message.error(errorMessage.network)
  }
}
